module.exports = __webpack_public_path__ + "static/media/Plus X Creative Partner_3.580d988f.mp4";